import HrBase from "pages/hr/hr";
import Loadable from "components/Loadable";
import {lazy} from "react";
import Dashboard from "pages/hr/dashboard/dashboard";
import HrAdminBase from "pages/hr/hr-admin/hr-admin";
import EmployeeDetails from "pages/hr/employees/details/EmployeeDetails";
import EmployeeAward from "../pages/hr/employees/awards/employee-award";
import Attendance from "./Attendance";
const Awards = Loadable(lazy(() => import('pages/hr/hr-admin/awards/awards')));
const EmployeeList = Loadable(lazy(() => import('pages/hr/employees/employees')));
const Department = Loadable(lazy(() => import('pages/hr/department/department')));
const Noticeboards = Loadable(lazy(() => import('pages/hr/hr-admin/noticeboards/noticeboards')));
const Holidays = Loadable(lazy(() => import('pages/hr/hr-admin/holidays/holidays')));
const Employeebase = Loadable(lazy(() => import('pages/hr/employees/EmployeeBase')));
const EmployeeAttendance = Loadable(lazy(() => import('pages/attendance/employee/attendance/employee-attendance')));
const UserLeaveApplications = Loadable(lazy(() => import('pages/attendance/employee/leave-applications/employee-leave-application')));
const EmployeeTask = Loadable(lazy(() => import('pages/hr/employees/tasks/employee-tasks')));
const ViewEmployeeTask = Loadable(lazy(() => import('pages/hr/employees/tasks/view-employee-task')));
const PayrollsList = Loadable(lazy(() => import('pages/hr/hr-admin/payrolls/payrollsList')));

const HRRoutes = {
    path: 'hr',
    element: <HrBase />,
    children: [
        {
            path: '',
            element: <Dashboard />
        },
        Attendance,
        {
            path: 'department',
            element: <Department />
        },
        {
            path: 'employees',
            children: [
                {
                    path: '',
                    element: <EmployeeList />,

                },
                {
                    path: ':employee_id',
                    element: <Employeebase />,
                    children:[
                        {
                            path: '',
                            element: <EmployeeDetails />,
                        },
                        {
                            path: 'attendance',
                            element: <EmployeeAttendance />,
                        },
                        {
                            path: 'awards',
                            element: <EmployeeAward />,
                        },
                        {
                            path: 'leaves',
                            element: <UserLeaveApplications />,
                        },
                        {
                            path: 'payrolls',
                            element: <EmployeeDetails />,
                        },
                        {
                            path: 'tasks',
                            children:[
                                {
                                    path:'',
                                    element:<EmployeeTask/>
                                },
                                {
                                    path:':employee_task_id',
                                    element:<ViewEmployeeTask/>
                                }
                            ]
                        },
                    ]
                },
            ]
        },
        {
            path: 'admin',
            element: <HrAdminBase />,
            children:[
                {
                    path:'awards',
                    element: <Awards />
                },
               
                {
                    path:'noticeboard',
                    element: <Noticeboards />
                },
                {
                    path:'holidays',
                    element: <Holidays />
                },
                {
                    path:'payrolls',
                    element: <PayrollsList />
                }
            ]
        },
    ]}
export default HRRoutes;
